module.exports = __webpack_public_path__ + "static/hotblack-coffee-about3-f4ed7b2587eae6432b4de75d99103633.png";